<template>
  <v-tooltip v-if="enabled && text" top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        small
        class="source-ref-icon"
        color="blue-grey lighten-1"
        v-bind="attrs"
        v-on="on"
      >
        mdi-information-outline
      </v-icon>
    </template>
    <div class="source-ref-tooltip">
      {{ text }}
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: 'SourceTooltipIcon',
  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>
